export interface ProfileIdentity {
  name: string | null;
  phone: string | null;
}

/**
 * Identity shown in the teacher's My Profile header.
 *
 * Settings → General owns name/phone (User is the single source of truth, see
 * user-registration-enhancement.md).
 * The profile-version copy of name/phone only refreshes on the next profile save
 * (ADR-044), so account values win and the version copy is only a fallback.
 */
export function resolveProfileIdentity({
  account,
  versionData,
}: {
  account?: { name?: string | null; phoneNumber?: string | null } | null;
  versionData?: { fullName?: string | null; phone?: string | null } | null;
}): ProfileIdentity {
  return {
    name: account?.name || versionData?.fullName || null,
    phone: account?.phoneNumber || versionData?.phone || null,
  };
}
